import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { createTracker } from 'usage-tracker';
import { getHubAndTierFromApiName } from './product';
const AMPLITUDE_APP_NAME = 'upgrades';
export const tracker = createTracker({
  standalone: true
});
export const getDeployableName = () => {
  var _window$hubspot;
  // @ts-expect-error the error notes that bender is not defined on the
  // window.hubspot object, but it's documented in the auth docs:
  // https://product.hubteam.com/docs/appsystems/team-os/user-setup-fe/useful-info.html#how-to-check-which-app-your-looking-at
  return ((_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 || (_window$hubspot = _window$hubspot.bender) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.currentProject) || getApp();
};
const cleanUpEventProperties = (eventProperties = {}) => {
  Object.keys(eventProperties).forEach(property => {
    var _eventProperties$prop;
    if (((_eventProperties$prop = eventProperties[property]) !== null && _eventProperties$prop !== void 0 ? _eventProperties$prop : undefined) === undefined) {
      delete eventProperties[property];
    }
  });
  return eventProperties;
};
const isApiBlackListed = () => {
  return window.location.href.indexOf('sales-iframes') !== -1 || window.location.origin === 'https://preview.hs-sites.com' || window.location.origin === 'https://preview.hs-sitesqa.com';
};
export const track = (eventKey, eventProperties) => {
  if (isApiBlackListed()) {
    return;
  }
  tracker.track(AMPLITUDE_APP_NAME, eventKey, cleanUpEventProperties(eventProperties));
};
const getUpgradeSourceFromQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('upgradeSource');
};
const getUpgradeConfigTrackingProperties = ({
  upgradeConfig
}) => {
  return {
    upgradeKey: upgradeConfig.upgradeKey,
    pointType: upgradeConfig.pointType,
    feature: upgradeConfig.featureStoreFeature
  };
};
export const getTrackingProperties = ({
  apiName,
  trackingData,
  upgradeConfig
}) => {
  const {
    hub,
    tier
  } = getHubAndTierFromApiName(apiName);
  const upgradeSource = getUpgradeSourceFromQueryParams();
  return Object.assign({
    app: trackingData.app,
    screen: trackingData.screen,
    subscreen: trackingData.subscreen,
    uniqueId: trackingData.uniqueId,
    apiName,
    source: trackingData.source,
    upgradeProduct: ApiNameToUpgradeProductMap[apiName],
    upgradeSource
  }, trackingData.usageLimitBannerData, {
    hub,
    tier
  }, upgradeConfig ? getUpgradeConfigTrackingProperties({
    upgradeConfig
  }) : {});
};